// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
 ( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        ecom: {
            product: {
                url: '/system/data/product',
                colorfamily: {
                    url: '/system/data/colorfamily-prices'
                }
            },
            quickorder: {
                url: '/system/data/quickorder'
            },
            download: {
                url: '/system/data/cart-download'
            },
            myorders: {
                url: '/system/data/orders',
                detail: {
                    url: '/system/data/orderdetail'
                },
                pdf: {
                    url: '/system/data/orderpdf'
                }
            },
            variants: {
                autoSelect: true
            },
            filters: {
                cleanUrl: false
            },
        },
        debug: {
            show: false,
            consoleType: 'log'
        },
        debounceDelay: {
            input: 500
        }
    } );
 }() );
